import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, started = true, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "112%" }}
            animate={started ? { y: "0%" } : { y: "112%" }}
            transition={{ duration: 1.1, ease: EASE, delay }}
        >
            {children}
        </motion.span>
    </span>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: EASE, delay }}
    >
        {children}
    </motion.div>
);

export const SectionTag = ({ index, label }) => (
    <div className="flex items-center gap-4">
        <span className="font-display text-sm italic text-gold">{index}</span>
        <span className="h-px w-10 bg-gold/50" />
        <span className="text-[11px] uppercase tracking-[0.35em] text-ash">{label}</span>
    </div>
);
